import {
  configureStore,
  combineReducers,
  createAction
} from '@reduxjs/toolkit';
import loaderReducer from './slices/loader';
import userDetailsReducer from './slices/userDetails';
import topBarHeadingReducer from './slices/topBarHeading';
import orderReducer from './slices/order';
import assetTypeListReducer from './slices/assetType';
import dashboardReducer from './slices/dashboard';
import profileReducer from './slices/profile';
import projectReducer from './slices/project';
import userAccessTeamReducer from './slices/userAccessTeam';
import documentTypeListReducer from './slices/documentType';
import mapPreferencesReducer from './slices/mapPreferences';

const appReducer = combineReducers({
  loader: loaderReducer,
  userDetails: userDetailsReducer,
  topBarHeading: topBarHeadingReducer,
  order: orderReducer,
  assetTypeList: assetTypeListReducer,
  dashboard: dashboardReducer,
  profile: profileReducer,
  project: projectReducer,
  userAccessTeam: userAccessTeamReducer,
  documentTypeList: documentTypeListReducer,
  mapPreferences: mapPreferencesReducer
});

export const logout = createAction('user/logout');

const rootReducer = (state, action) => {
  if (action.type === logout.type) {
    state = undefined; // Resets the entire state
  }
  return appReducer(state, action);
};

export default configureStore({
  reducer: rootReducer
});
